import { HttpClient } from '@angular/common/http';
import { Injectable,OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { ExamsService } from './exams.service';
import { LoginService } from './login.service';
import { GastroFormsService } from './gastro-forms.service';

@Injectable({
  providedIn: 'root'
})
export class RecoveryService implements OnDestroy {
  measurements:UntypedFormGroup
  patMeasurements

  constructor(private es:ExamsService, private fb:UntypedFormBuilder, private http:HttpClient, private gsF:GastroFormsService, public ls:LoginService) { 
    this.resetForm();
    this.gsF.formLoaded$.subscribe(()=>{
      this.getRecoveryMeas()
    })
  }

  
  resetForm(){
    this.measurements = this.fb.group({
      AutoIndex: [''],
      Temp: [''],
      Pulse: [''],
      bpDyastolic: [''],
      bpSystolic:[''],
      Saturation: [''],
      CheckTime:['']
    })
  }

  getRecoveryMeas(FormID:Number=this.gsF.FormIndex){
    if(FormID)
      this.http.get(`/api/gastro/getRecoveryMeas/${FormID}`).subscribe((data) => {
        this.patMeasurements =data;
      })
    
  }
  saveNew(FormID:Number=this.gsF.FormIndex){
    if(this.measurements.value.Temp || this.measurements.value.Pulse || (this.measurements.value.bpDyastolic && this.measurements.value.bpSystolic) || this.measurements.value.Saturation){
      this.http.post(`/api/gastro/SaveMeasRecovery/${FormID}`, {meas: this.measurements.value, pat:this.es.patServ.currentPatient},).subscribe((data) => {
        this.measurements.reset();
        this.getRecoveryMeas();
        // if(this.ls.isUSG)
        //   this.Medication.get('Unit').setValue('mg');
      })    
    }
  }

  // deleteMed(index:number){
  //   this.http.get(`/api/gastro/deleteMed/${index}`).subscribe((data) => {
  //     console.log(data);
  //     this.getAllMedication()
  //   })
  // }
  ngOnDestroy (){
    this.gsF.formLoaded$.unsubscribe()
  }
}
